import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import mapStateToProps from '../../../store/mapStateToProps';
import mapDispatchToProps from '../../../store/mapDispatchToProps';
import { hit } from '../../metrics';
import HelmetSite from '../HelmetSite';
import CaseFooterNew from '../CaseFooterNew';
import './style.css';

const base = '/cases/img/highlife';

const featureSlides = [
  { title: 'Приватные места для отдыха', image: 'slide-3.webp' },
  { title: 'Детская площадка 1 очередь', image: 'slide-5.webp' },
  { title: 'Детская площадка 2 очередь', image: 'slide-6.webp' },
  { title: 'Сухой фонтан', image: 'slide-4.webp' },
  { title: 'Баскетбольная площадка', image: 'slide-2.webp' },
  { title: 'Зоны воркаута', image: 'slide-1.webp' }
];

const mobileCopy = {
  '03-copy': {
    title: 'Концепция',
    text: 'В основе дизайна — погружение через чувственное восприятие: контраст и ритм задают динамику, крупные визуальные сцены сменяются лаконичными блоками, ведя от общего впечатления к деталям.'
  },
  '07-copy': {
    title: 'Цвет и свет',
    text: 'Глубокие тёмные тона создают ощущение приватности, постепенно уступая место тёплым и светлым акцентам. По мере скролла атмосфера меняется от камерной к более открытой и динамичной — это усиливает эффект погружения и удерживает внимание.'
  },
  '10-copy': {
    title: 'Контент',
    text: 'Заставка первого экрана работает как трейлер — интригует и приглашает смотреть дальше. Панорамы из окон в разное время суток дают пользователю увидеть вид, который откроется резидентам, ещё до покупки.'
  }
};

const introCopy = 'Разработали сайт жилого комплекса премиум-класса HIGH LIFE для девелопера PIONEER с задачей перевести проект из строгого делового позиционирования в эмоциональное, тёплое и премиальное восприятие через визуальный образ и сторителлинг.';

const comfortCards = [
  { title: 'Обеспечение безопасности', image: 'comfort-source-1.webp' },
  { title: 'Скоростные лифты', image: 'comfort-source-2.webp' },
  { title: 'Доступ в здание', image: 'comfort-source-3.webp' },
  { title: 'Очищение воды', image: '05-comfort-card-4.webp' }
];

const Media = ({ name, alt, parallax = false, copy, intro = false }) => (
  <section className={`highlife-media highlife-media--${name}`}>
    {!copy && (intro ? (
      <div className="highlife-cover-visual">
        <img className={parallax ? 'highlife-parallax' : ''} src={`${base}/${name}.webp`} alt={alt} loading={name === '01-cover' ? 'eager' : 'lazy'} />
      </div>
    ) : <img className={parallax ? 'highlife-parallax' : ''} src={`${base}/${name}.webp`} alt={alt} loading="lazy" />)}
    {copy && (
      <div className="highlife-copy">
        <h2>{copy.title}</h2>
        <p>{copy.text}</p>
      </div>
    )}
    {intro && (
      <div className="highlife-intro">
        <div>
          <h2>Жилой комплекс «Хай Лайф»</h2>
          <dl>
            <div><dt>Клиент</dt><dd>Pioneer</dd></div>
            <div><dt>Виды работ</dt><dd>Сайт</dd></div>
          </dl>
        </div>
        <p>{introCopy}</p>
      </div>
    )}
  </section>
);

class HeroVideo extends Component {
  state = { started: false };

  setVideo = node => { this.video = node; };

  play = () => {
    if (!this.video) return;
    const playback = this.video.play();
    if (playback && playback.then) {
      playback.then(() => this.setState({ started: true })).catch(() => {});
    } else {
      this.setState({ started: true });
    }
  };

  playFromContainer = () => {
    if (!this.state.started && window.matchMedia('(max-width: 900px)').matches) this.play();
  };

  render() {
    return (
      <section className="highlife-media highlife-media--11-ribbon highlife-hero-video" onClick={this.playFromContainer}>
        {!this.state.started && <img className="highlife-hero-video__poster" src={`${base}/11-ribbon.webp`} alt="Интерфейс сайта High Life" />}
        <video
          ref={this.setVideo}
          className={this.state.started ? 'is-started' : ''}
          playsInline
          preload="metadata"
          controls={this.state.started}
          onEnded={() => this.setState({ started: false })}
        >
          <source src={`${base}/hero-video.mp4`} type="video/mp4" />
        </video>
        {!this.state.started && (
          <button className="highlife-hero-video__play" type="button" onClick={this.play} aria-label="Воспроизвести видео High Life">
            <img src={`${base}/play.svg`} alt="" />
          </button>
        )}
      </section>
    );
  }
}

const SplitMedia = ({ name, height, alt, parallax = false, video, videoSide, videoRef, split = 0.5, mobileComfort = false, mobileLeft, rightCopy }) => (
  <section
    className={`highlife-media highlife-split highlife-split--${name}`}
    style={{
      '--highlife-left-ratio': `${1920 * split} / ${height}`,
      '--highlife-right-ratio': `${1920 * (1 - split)} / ${height}`,
      '--highlife-left-width': `${100 / split}%`,
      '--highlife-right-width': `${100 / (1 - split)}%`,
      '--highlife-right-offset': `${-100 * split / (1 - split)}%`
    }}
  >
    <div className="highlife-split__desktop">
      <img className={parallax ? 'highlife-parallax' : ''} src={`${base}/${name}.webp`} alt={alt} loading="lazy" />
      {video && (
        <video ref={videoRef} className={`highlife-split__video highlife-split__video--${videoSide}`} muted loop playsInline preload="metadata">
          <source src={`${base}/${video}`} type="video/mp4" />
        </video>
      )}
    </div>
    <div className="highlife-split__mobile">
      {mobileComfort ? (
        <React.Fragment>
          <div className="highlife-comfort__video">
            <video ref={videoRef} muted loop playsInline preload="metadata">
              <source src={`${base}/${video}`} type="video/mp4" />
            </video>
          </div>
          <div className="highlife-comfort__content">
            <h2>Место, где технологии<br />поддерживают комфорт<br />и спокойствие</h2>
            <p>Технологические решения комплекса создают невидимый комфорт, который резиденты ощущают повсеместно — вся инфраструктура спроектирована так, чтобы облегчить повседневную жизнь.</p>
            <div className="highlife-comfort__cards">
              {comfortCards.map(card => (
                <figure key={card.title}>
                  <figcaption>{card.title}</figcaption>
                  <img src={`${base}/${card.image}`} alt={card.title} loading="lazy" />
                </figure>
              ))}
            </div>
          </div>
        </React.Fragment>
      ) : ['left', 'right'].map(side => (
        <div className={`highlife-split__half highlife-split__half--${side}${side === 'left' && mobileLeft ? ' highlife-split__half--standalone' : ''}${side === 'right' && rightCopy ? ' highlife-split__half--copy' : ''}`} key={side}>
          {side === 'right' && rightCopy ? (
            <div className="highlife-split__right-copy"><p>{rightCopy}</p></div>
          ) : <img className={side === 'left' && mobileLeft ? 'highlife-split__standalone' : ''} src={`${base}/${side === 'left' && mobileLeft ? mobileLeft : `${name}.webp`}`} alt="" loading="lazy" />}
          {video && videoSide === side && (
            <video ref={videoRef} muted loop playsInline preload="metadata">
              <source src={`${base}/${video}`} type="video/mp4" />
            </video>
          )}
        </div>
      ))}
    </div>
  </section>
);

const StripMedia = ({ name, alt }) => (
  <section className={`highlife-media highlife-strip highlife-strip--${name}`}>
    <img className="highlife-strip__desktop" src={`${base}/${name}.webp`} alt={alt} loading="lazy" />
    <div className="highlife-strip__mobile" aria-hidden="true">
      {['mobile-line-1.webp', 'mobile-line-2.webp', 'mobile-line-3.webp', 'mobile-line-4.webp'].map(image => (
        <img className="highlife-strip__line" src={`${base}/${image}`} alt="" loading="lazy" key={image} />
      ))}
    </div>
  </section>
);

class Highlife extends Component {
  state = { activeSlide: 3 };

  videoNodes = [];

  setVideoRef = node => {
    if (node && this.videoNodes.indexOf(node) === -1) this.videoNodes.push(node);
  };

  setPanorama = node => { this.panorama = node; };
  setPanoramaViewport = node => { this.panoramaViewport = node; };

  componentDidMount() {
    if (this.props.pathname === '/projects/highlife/' || this.props.pathname === '/projects/highlife') {
      this.props.setProjectName('highlife');
      $('body').addClass('case-expanded hash-highlife');
      this.props.changeCase(null);
    }

    window.scrollTo(0, 0);
    hit(window.location.pathname);

    this.sliderTimer = window.setInterval(() => {
      this.setState(({ activeSlide }) => ({ activeSlide: (activeSlide + 1) % 6 }));
    }, 3200);

    this.initVideos();
    this.initParallax();
    this.initPanorama();
    this.fadeTimer = window.setTimeout(() => $('body').addClass('fadepage'), 120);
  }

  componentWillUnmount() {
    window.clearInterval(this.sliderTimer);
    window.clearTimeout(this.fadeTimer);
    if (this.mediaObserver) this.mediaObserver.disconnect();
    if (this.panoramaTween) {
      if (this.panoramaTween.scrollTrigger) this.panoramaTween.scrollTrigger.kill();
      this.panoramaTween.kill();
    }
    if (this.motionTweens) {
      this.motionTweens.forEach(tween => {
        if (tween.scrollTrigger) tween.scrollTrigger.kill();
        tween.kill();
      });
    }
    this.videoNodes.forEach(video => video.pause());
    $('body').removeClass('fadepage hash-highlife');
  }

  initVideos() {
    this.mediaObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const promise = entry.target.play();
          if (promise) promise.catch(() => {});
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.08 });
    this.videoNodes.forEach(video => this.mediaObserver.observe(video));
  }

  initParallax() {
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!window.gsap || !window.ScrollTrigger || reduceMotion || window.innerWidth <= 700) return;
    window.gsap.registerPlugin(window.ScrollTrigger);
    this.motionTweens = window.gsap.utils.toArray('#case-highlife .highlife-parallax').map((image, index) => (
      window.gsap.fromTo(
        image,
        { yPercent: index % 2 ? -3 : 3, scale: 1.07 },
        {
          yPercent: index % 2 ? 3 : -3,
          scale: 1.07,
          ease: 'none',
          scrollTrigger: {
            trigger: image.closest('section'),
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1.2
          }
        }
      )
    ));
  }

  initPanorama() {
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!this.panorama || !this.panoramaViewport || !window.gsap || !window.ScrollTrigger || reduceMotion) return;

    window.gsap.registerPlugin(window.ScrollTrigger);
    const createTween = () => {
      if (this.panoramaTween) return;
      this.panoramaTween = window.gsap.fromTo(
        this.panorama,
        { x: 0 },
        {
          x: () => Math.max(
            Math.min(this.panoramaViewport.offsetWidth - this.panorama.offsetWidth, 0) * 0.12,
            -this.panoramaViewport.offsetWidth * 0.1
          ),
          ease: 'none',
          scrollTrigger: {
            trigger: this.panoramaViewport,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 4.5,
            invalidateOnRefresh: true
          }
        }
      );
    };

    if (this.panorama.complete) createTween();
    else this.panorama.addEventListener('load', createTween, { once: true });
  }

  renderSlider() {
    const { activeSlide } = this.state;
    const getPosition = index => {
      const offset = (index - activeSlide + featureSlides.length) % featureSlides.length;
      if (offset === 0) return 'is-active';
      if (offset <= featureSlides.length / 2) return `is-next-${offset}`;
      return `is-prev-${featureSlides.length - offset}`;
    };

    return (
      <section className="highlife-media highlife-features">
        <div className="highlife-features__copy">
          <h2>Исключительные<br />особенности</h2>
          <div className="highlife-features__nav">
            {featureSlides.map((slide, index) => (
              <span className={getPosition(index)} key={slide.title}>{slide.title}</span>
            ))}
          </div>
        </div>
        <div className="highlife-features__slides">
          {featureSlides.map((slide, index) => (
            <img
              className={getPosition(index)}
              src={`${base}/${slide.image}`}
              alt={slide.title}
              loading="lazy"
              key={slide.title}
            />
          ))}
        </div>
      </section>
    );
  }

  renderPanorama() {
    return (
      <section className="highlife-panorama" ref={this.setPanoramaViewport} aria-label="Панорамный вид из квартиры">
        <img ref={this.setPanorama} className="highlife-panorama__view" src={`${base}/panorama-view.webp`} alt="Панорама Москвы" loading="lazy" />
        <img className="highlife-panorama__window" src={`${base}/panorama-window.webp`} alt="Интерьер квартиры с панорамными окнами" loading="lazy" />
      </section>
    );
  }

  render() {
    return (
      <div className="case">
        <div className="case-content" id="case-highlife">
          <h1 className="highlife-visually-hidden">Жилой комплекс «Хай Лайф»</h1>
          <Media name="01-cover" alt="Жилой комплекс Хай Лайф" intro />
          <Media name="02-site" alt="Главная страница сайта Хай Лайф" parallax />
          <Media name="03-copy" alt="Описание концепции сайта" copy={mobileCopy['03-copy']} />
          <SplitMedia name="04-location" height={820} alt="Расположение жилого комплекса" video="location.mp4" videoSide="right" videoRef={this.setVideoRef} />
          <SplitMedia name="05-comfort" height={1080} split={0.386} alt="Комфорт и технологии жилого комплекса" video="lobby.mp4" videoSide="left" videoRef={this.setVideoRef} mobileComfort />
          <Media name="06-visual" alt="Визуальный образ проекта" parallax />
          <Media name="07-copy" alt="Описание архитектуры" copy={mobileCopy['07-copy']} />
          <SplitMedia name="08-architecture" height={1058} alt="Архитектура жилого комплекса" parallax />
          {this.renderSlider()}
          <Media name="10-copy" alt="Описание цифрового проекта" copy={mobileCopy['10-copy']} />
          <HeroVideo />
          {this.renderPanorama()}
          <SplitMedia
            name="13-site-grid"
            height={1080}
            split={0.663}
            alt="Страницы сайта Хай Лайф"
            parallax
            mobileLeft="mobile-site-full.webp"
            rightCopy="Мобильная версия сайта полностью повторяет функционал основной версии, обеспечивая пользователям доступ ко всем необходимым функциям в любое время и в любом месте. Интерфейс оптимизирован для удобства использования на мобильных устройствах, сохраняя фирменный стиль проекта и гармоничное восприятие даже на небольших экранах."
          />
          <StripMedia name="14-mobile-grid" alt="Мобильная версия сайта Хай Лайф" />

          <CaseFooterNew
            to="/projects/opus/"
            title="Жилой комплекс «Опус»"
            img="/cases/img/opus/next.webp"
            full={true}
          />
        </div>
        <HelmetSite title="Жилой комплекс «Хай Лайф»" />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Highlife);
